import breakpoints from '@assets/theme/breakpoints';
import palette from '@assets/theme/palette';
import { styled } from '@mui/material';

export const FavoritesMenuItemStyled = styled('div')`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-areas:
    'content price'
    'content actions';
  grid-template-rows: auto 1fr;
  gap: 8px 16px;
  align-items: start;

  .calculations-menu__item-content {
    grid-area: content;
  }

  .price {
    grid-area: price;
    white-space: nowrap;
    font-weight: 600;
    font-size: 16px;
    color: black;
    text-align: right;
  }

  .calculations-menu__actions {
    grid-area: actions;
    justify-content: flex-end;
  }

  .order-product-component {
    display: grid;
    gap: 12px;
    color: ${palette.light.common.black};

    .MuiTypography-h4 {
      font-size: 16px;
      font-weight: 500;
      line-height: inherit;
      letter-spacing: inherit;
    }

    .cargo {
      font-size: 14px;
      font-weight: 500;

      &--item {
        padding-left: 12px;
      }

      &--title {
        padding-left: 0;
        padding-bottom: 4px;
        font-size: 12px;
        font-weight: 300;
        color: #707070;
      }
    }

    .route-marks {
      display: grid;
      grid-auto-columns: min-content;
      grid-auto-flow: column;
      grid-gap: 12px;

      .route-is-not-full {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-gap: 6px;
        align-items: center;
        line-height: 0;
        border: 2px solid #ffa630;
        padding: 6px 10px;
        border-radius: 8px;
        cursor: default;
        white-space: nowrap;

        > svg {
          font-size: 13px;
          color: #ffa630;
        }

        > div {
          font-size: 13px;
          font-weight: 600;
          line-height: 0;
          color: #ffa630;
        }
      }
    }
  }

  @media (max-width: ${breakpoints.values.sm}px) {
    grid-template-areas:
      'price actions'
      'content content';
    grid-template-rows: auto auto;
    align-items: center;

    .price {
      text-align: left;
      font-size: 14px;
    }
  }
`;
